<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-01 09:24:47
    Description : 页面底部声明
  -->
  <div class="gaia-footer page" :style="{ background: background }">
    <div class="flex" style="width: 1200px; margin: 0 auto">
      <div class="flex-item" style="min-width: 900px">
        <div class="gaiamount">Gaiamount</div>
        <div class="flex">
          <div class="flex-item">
            <div class="flex">
              <div class="flex-item">
                <a href="/desktop/gaia-material/list" target="_blank">素材</a>
              </div>
              <div class="flex-item" style="margin-left: 24px">
                <a href="/works/list" target="_blank"> 作品 </a>
              </div>
              <div class="flex-item" style="margin-left: 24px">
                <a href="/group/group/list" target="_blank">创作组</a>
              </div>
              <div class="flex-item" style="margin-left: 12px">
                <a href="/college/private/collegeIndex" target="_blank">学院</a>
              </div>
              <div class="flex-item">
                <a
                  href="/desktop/gaia-48/main"
                  target="_blank"
                  style="margin-left: 12px"
                >
                  Gaia48
                </a>
              </div>
              <div class="flex-item">
                <a
                  href="/account/member"
                  target="_blank"
                  style="margin-left: 12px"
                >
                  会员
                </a>
              </div>
              <div class="flex-item">
                <a style="margin-left: 38px"> 其他 </a>
              </div>
            </div>
            <div class="flex">
              <div class="flex-item">
                <a href="/desktop/gaia-material/list" target="_blank">
                  上传素材
                </a>
              </div>
              <div class="flex-item" style="margin-left: 0">
                <a href="/works/upload" target="_blank">上传作品</a>
              </div>
              <div class="flex-item" style="margin-left: 0">
                <a href="/group/group/list" target="_blank">创建小组</a>
              </div>
              <div class="flex-item" style="margin-left: 0">
                <a href="/college/private/upload" target="_blank">投稿</a>
              </div>
              <div class="flex-item" style="margin-left: 14px">
                <a href="/desktop/gaia-48/upload" target="_blank">上传</a>
                <a href="http://gaiamount.mikecrm.com/VV6iRuZ" target="_blank"
                  >报名</a
                >
              </div>
              <div class="flex-item" style="margin-left: 26px">
                <a href="/account/member" target="_blank">开通会员</a>
              </div>
              <div class="flex-item" style="margin-left: 14px">
                <a href="/desktop/richPage?type=0" target="_blank">版权声明</a>
                <a href="/desktop/richPage?type=1" target="_blank">服务协议</a>
                <a href="/desktop/richPage?type=2" target="_blank">上传协议</a>
              </div>
              <div class="flex-item" style="margin-left: 14px">
                <a href="/desktop/about?type=1" target="_blank">关于我们</a>
                <a href="/desktop/about?type=0" target="_blank">联系我们</a>
              </div>
            </div>
          </div>
        </div>
        <el-divider />
        <div>
          <!--
          <div class="zero">
            <tencent-qq
              theme="two-tone"
              size="20"
              fill="#ffffff"
              @click="jumpTo"
            />
          </div>
          -->
          <el-popover placement="top-start" width="200" trigger="hover">
            <div style="text-align: center">
              <img src="@/assets/images/gaiadaily-scode.jpg" />
              <div style="color: #717171; font-size: 14px">
                <div>GaiaDaily</div>
                <div>官方微信</div>
              </div>
            </div>
            <div class="zero" slot="reference">
              <wechat theme="outline" size="20" fill="#ffffff" />
            </div>
          </el-popover>
          <el-popover placement="top-start" width="200" trigger="hover">
            <div style="text-align: center">
              <img src="@/assets/images/wechat-scode.png" />
              <div style="color: #717171; font-size: 14px">
                <div>尊正中国</div>
                <div>官方微信</div>
              </div>
            </div>
            <div class="zero" slot="reference">
              <wechat theme="outline" size="20" fill="#ffffff" />
            </div>
          </el-popover>
          <el-popover placement="top-start" width="200" trigger="hover">
            <div style="text-align: center">
              <img src="@/assets/images/sina-scode.jpg" />
              <div style="color: #717171; font-size: 14px">
                <div>尊正中国</div>
                <div>官方微博</div>
              </div>
            </div>
            <div class="zero" slot="reference">
              <weibo theme="outline" size="20" fill="#ffffff" />
            </div>
          </el-popover>
        </div>
      </div>
      <div class="flex-item" style="padding: 40px 0 0 0">
        <p style="border: none">
          声明 <br />
          Gaiamount 所有内容之版权归原作者所有，任何商业用途均须取得授权;
          未经授权将内容盗取或用作他处, 我们将保留追究侵权者法律责任之权利.
          Gaiamount 鼓励原创,请勿上传任何侵犯他人权利或违反相关法律法规之内容。
          <br />
          <br />
          © 2016-2025 Gaiamount 版权所有
          <br />
          <a
            href="http://beian.miit.gov.cn/"
            target="_blank"
            style="display: inline"
          >
            粤ICP备 06032157 号
          </a>

          <a
            href="https://szcert.ebs.org.cn/a7663ac5-dfb6-4be8-ac42-0f339eefc777"
            target="_blank"
            style="float: right; margin-top: 10px"
          >
            <img src="@/assets/images/img_szcert.png" />
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { TencentQq, Wechat, Weibo } from "@icon-park/vue";
export default {
  components: { TencentQq, Wechat, Weibo },
  data() {
    return {
      background: "",
    };
  },
  created() {
    if (this.$route.query.background === "black") {
      this.background = "#010101";
    }
  },
  methods: {
    jumpTo() {
      open(
        "http://sighttp.qq.com/authd?IDKEY=71b863d14c5e33e85652e5cd3b9e73ea45f5af34f7f29e20"
      );
    },
  },
};
</script>
<style lang="less" scoped>
.gaiamount {
  color: #616161;
  padding: 20px 0 20px;
  font-size: 20px;
  font-weight: 700;
}
.gaia-footer {
  width: 100%;
  min-width: 1100px;
  box-sizing: border-box;
  height: 260px;
  padding: 24px 0;
  font-size: 12px;
  background: #ffffff;
  color: #979797;
}
a {
  display: block;
  color: #979797;
  text-decoration: none;
  margin: 0 20px 8px 0;
}
.flex {
  display: flex;
}
p {
  width: 300px;
  line-height: 18px;
  border: #e5e5e5 solid 1px;
  padding: 2px 6px;
}
.page {
  min-width: 1300px;
  margin: 0 auto;
  padding-left: 50px;
  padding-right: 50px;
}
.zero {
  display: inline-block;
  margin-right: 10px;
  width: 30px;
  height: 30px;
  line-height: 40px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
}
</style>
